import React, { useState, useEffect } from 'react';
import Loading from './Loading';

const withLoading = (WrappedComponent) => {
  return function WithLoadingComponent(props) {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
      // Simulate loading time or replace with actual loading logic
      const timer = setTimeout(() => {
        setIsLoading(false);
      }, 1000);

      return () => clearTimeout(timer);
    }, []);

    return (
      <>
        {isLoading ? (
          <Loading />
        ) : (
          <WrappedComponent {...props} />
        )}
      </>
    );
  };
};

export default withLoading; 